import React, { useEffect, useState } from "react";
import {
  Group,
  Text,
  Accordion,
  Checkbox,
  TextInput,
  HoverCard,
  Box,
  Flex,
  createStyles,
  Button,
} from "@mantine/core";

import moment from "moment-timezone";
import { useSelector } from "react-redux";
import { RxCross2 } from "react-icons/rx";

const useStyles = createStyles((theme) => ({
  accordion: {
    "& .mantine-Accordion-control": {
      backgroundColor: "#F4F3FF !important",
      borderTopLeftRadius: "15px !important",
      borderTopRightRadius: "15px !important",
      borderBottomColor: "#D9D9D9 !important",
      borderBottomWidth: "1px !important",
      borderBottomStyle: "solid !important",

      borderLeftColor: "#D9D9D9 !important",
      borderLeftWidth: "1px !important",
      borderLeftStyle: "solid !important",
      borderRightColor: "#D9D9D9 !important",
      borderRightWidth: "1px !important",
      borderRightStyle: "solid !important",
    },
    "& .mantine-Accordion-content": {
      borderBottomLeftRadius: "15px !important",
      backgroundColor: "#fff !important",
      borderBottomRightRadius: "15px !important",
      border: "none",
    },
    "& .mantine-Accordion-item": {
      border: "1px solid #D9D9D9",
      borderRadius: "16px !important",
    },
  },
  hoverTextField: {
    border: "1px solid #F2F4F7",
    borderRadius: "5px",
    padding: "5px 10px",
  },
}));

function AccordionLabel({ label, description }) {
  return (
    <Group>
      <div>
        <Text>{label}</Text>
        <Text size="sm" c="dimmed" fw={400}>
          {description}
        </Text>
      </div>
    </Group>
  );
}

function AccordionCheck({
  type,
  Data,
  Heading,
  checksDone,
  setChecks,
  checks,
  userType,
  userId,
  viewOnly,
  shift,
  profile,
  tasks,
  activityFields,
  selectedStaff,
  selectedStaffData,
  requiredCheckedFields,
  isFromServicePlan,
  activePlan,
}) {
  console.log("🚀 ~ AccordionCheck ~ type:", type);
  const { timeZone } = useSelector((state) => state.profile);
  const [checkboxStates, setCheckboxStates] = useState({});
  const [inputValues, setInputValues] = useState({});
  const { classes } = useStyles();
  let filterActivity = activityFields?.map((item) => item?.field?.name);
  console.log("🚀 ~ AccordionCheck ~ filterActivity:", filterActivity);

  // let mappedDataId = Data?.map((data, index) => data?._id);
  // let mappedActivityId = activityFields?.map((item) => item?.field);
  // let filterActivityVal = activityFields?.map((item) => item?.textField);
  // const [fieldText, setFieldText] = useState();
  // let hasId = mappedDataId.filter((id) => mappedActivityId?.includes(id));

  const handleCheckboxChange = (id, isChecked) => {
    setCheckboxStates((prev) => ({
      ...prev,
      [id]: isChecked,
    }));
    // setFieldText(id);

    if (isChecked) {
      setChecks((prev) => [
        ...prev,
        {
          field: id,
          // staff: profile?.user?.type === "staff" ? userId : selectedStaff,
          // staff:  userId,
          staff: selectedStaffData?.id,
          shift: shift || "",
          textField: inputValues[id] || "",
        },
      ]);
    } else {
      setChecks((prev) => prev.filter((item) => item.field !== id));
    }
  };

  useEffect(() => {
    // Initialize both checkbox states and input values from checks
    const initialCheckboxes = {};
    const initialInputs = {};

    checks.forEach((check) => {
      initialCheckboxes[check.field] = true;
      if (check.textField) {
        initialInputs[check.field] = check.textField;
      }
    });

    // setCheckboxStates(initialCheckboxes);
    setInputValues(initialInputs);
  }, [checks]); // Re-run when checks change

  const handleInputChange = (id, value) => {
    setInputValues((prev) => ({
      ...prev,
      [id]: value,
    }));
    setChecks((prev) =>
      prev.map((item) =>
        item.field === id ? { ...item, textField: value } : item,
      ),
    );
  };

  const charactersList = [
    {
      id: "bender",
      label: Heading,
      content: (
        <div>
          {Data?.map((data) => {
            let alreadyChecked = {};
            if (type == "add") {
              alreadyChecked = activityFields?.filter(
                (_v) => _v?.field?._id === data?._id,
              )?.[0];
            } else {
              alreadyChecked = checksDone?.filter(
                (_v) => _v?.field?._id === data?._id,
              )?.[0];
            }
            let index = checks?.findIndex((item) => item.field === data?._id);
            let indexForDisabled = checks?.find(
              (item) =>
                item.field === data?._id &&
                item?.staff === userId &&
                item.shift === shift,
            );
            const isRequired = requiredCheckedFields?.find(
              ({ _id }) => _id === data?._id,
            );

            const activePlanField =
              activePlan?.activitiesOfDailyLiving?.fieldsDone?.find(
                (f) => f.field === data?._id,
              );
            return (
              <HoverCard
                width={300}
                radius={"lg"}
                shadow="md"
                disabled={
                  // activePlan
                  //   ? activePlanField
                  //     ? false
                  //     : true
                  //   : isFromServicePlan && type !== "add"
                  //     ? checks?.find((c) => c.field === data?._id)
                  //       ? false
                  //       : true
                  //     :
                  activePlan
                    ? true
                    : filterActivity?.includes(data?.name) ||
                        checksDone?.[index]?.checkedAt
                      ? false
                      : true
                }
              >
                <HoverCard.Target>
                  <div key={data?._id} style={{ margin: "10px" }}>
                    <Checkbox
                      color="gray"
                      variant="outline"
                      style={{
                        marginBottom: "10px",
                      }}
                      styles={{
                        label: {
                          backgroundColor:
                            // : activePlan
                            //   ? activePlanField
                            //     ? "#FFF6ED !important"
                            //     : "#F2F4F7 !important"
                            //   : isFromServicePlan && type !== "add"
                            //     ? checks?.find((c) => c.field === data?._id)
                            //       ? "#FFF6ED !important"
                            //       : "#F2F4F7 !important"
                            activePlan
                              ? "#F2F4F7 !important"
                              : filterActivity?.includes(data?.name) ||
                                  checksDone?.[index]
                                ? "#FFF6ED !important"
                                : "#F2F4F7 !important",

                          color:
                            // : activePlan
                            //   ? activePlanField
                            //     ? "#C4320A !important"
                            //     : "#525252 !important"
                            //   : isFromServicePlan && type !== "add"
                            //     ? checks?.find((c) => c.field === data?._id)
                            //       ? "#C4320A !important"
                            //       : "#525252 !important"
                            activePlan
                              ? "#525252 !important"
                              :
                            filterActivity?.includes(data?.name) ||
                            checksDone?.[index]
                              ? "#C4320A !important"
                              : "#525252 !important",
                          padding: "5px 10px",
                          borderRadius: "30px",
                          marginLeft: "10px",
                        },
                      }}
                      checked={index !== -1 ? true : false}
                      // checked={!!checkboxStates[data?._id]}
                      disabled={
                        viewOnly
                          ? true
                          : (index !== -1 &&
                                !indexForDisabled &&
                                userType === "staff") ||
                              (isFromServicePlan && type === "view")
                            ? true
                            : false
                      }
                      key={data?._id}
                      onChange={(e) =>
                        handleCheckboxChange(data?._id, e.target.checked)
                      }
                      label={`${data?.name}`}
                    />

                    {((checkboxStates[data?._id] && type !== "view") ||
                      (index !== -1 && isRequired)) &&
                      !isFromServicePlan && (
                        <TextInput
                          ml={30}
                          my={10}
                          radius={"md"}
                          readOnly={
                            isFromServicePlan && type === "view" ? true : false
                          }
                          placeholder="Add Text"
                          value={inputValues[data?._id] || ""}
                          onChange={(e) =>
                            handleInputChange(data?._id, e.target.value)
                          }
                          error={
                            isRequired && !inputValues[data?._id]
                              ? "Required"
                              : undefined
                          }
                        />
                      )}
                  </div>
                </HoverCard.Target>

                <HoverCard.Dropdown
                  radius="lg"
                  position="bottom"
                  style={{
                    maxHeight: "250px", // fixed height
                    overflowY: "auto", // scrollable
                  }}
                >
                  <Flex direction={"column"} gap={5}>
                    <Box key={data?._id} className={classes.hoverTextField}>
                      <Text ff={"Inter"} fw={700} fz={16}>
                        {checksDone?.[index]?.staff?.name ||
                          selectedStaffData?.name}
                      </Text>
                      <Text ff={"Inter"} fw={500} fz={12} c={"#A3A3A3"}>
                        {moment
                          .tz(alreadyChecked?.checkedAt, timeZone)
                          .format("MMM DD, hh:mm a")}
                      </Text>
                      <Box className={classes.hoverTextField}>
                        <Text
                          ff={"Inter"}
                          fw={500}
                          fz={12}
                          c={
                            checksDone?.[index]?.textField === ""
                              ? "#A3A3A3"
                              : "#000"
                          }
                        >
                          {activePlan
                            ? activePlanField?.textField || "No Text"
                            : isFromServicePlan
                              ? checks?.find((c) => c.field === data?._id)
                                  ?.textField || "No Text"
                              : alreadyChecked?.textField || "No Text"}
                          {/* {alreadyChecked?.textField || "No Text"} */}
                        </Text>
                      </Box>
                    </Box>

                    {/* 🔹 Past textEntries from checksDone (read-only history) */}
                    {alreadyChecked?.textEntries?.map((entry) => (
                      <Box key={entry?._id} className={classes.hoverTextField}>
                        <Flex direction="column" gap={4}>
                          {/* <Flex justify="space-between" align="center"> */}
                          <Text ff={"Inter"} fw={700} fz={16}>
                            {entry?.staffName}
                          </Text>
                          <Text ff={"Inter"} fw={500} fz={12} c={"#A3A3A3"}>
                            {moment
                              .tz(entry?.checkedAt, timeZone)
                              .format("MMM DD, hh:mm a")}
                          </Text>
                        </Flex>
                        <Box className={classes.hoverTextField}>
                          <Text
                            ff={"Inter"}
                            fw={500}
                            fz={12}
                            c={entry?.text ? "#000" : "#A3A3A3"}
                          >
                            {entry?.text || "No Text"}
                          </Text>
                          {/* </Flex> */}
                        </Box>
                      </Box>
                    ))}

                    {/* Existing Text Entries */}
                    <Box>
                      {(
                        checks.find((c) => c.field === data?._id)
                          ?.textEntries || []
                      ).map((entry, idx) => (
                        <Flex
                          key={idx}
                          align="start"
                          direction="column"
                          gap={8}
                          mt={5}
                        >
                          <Flex justify="space-between" align="center" w="100%">
                            <Text ff={"Inter"} fw={500} fz={12} c={"#000"}>
                              {selectedStaffData?.name}:{" "}
                            </Text>
                            {/* ❌ Remove Button */}
                            <Button
                              size="xs"
                              color="red"
                              variant="light"
                              onClick={() => {
                                setChecks((prev) =>
                                  prev.map((item) =>
                                    item.field === data?._id
                                      ? {
                                          ...item,
                                          textEntries: item.textEntries?.filter(
                                            (_, i) => i !== idx,
                                          ),
                                        }
                                      : item,
                                  ),
                                );
                              }}
                            >
                              <RxCross2 />
                            </Button>
                          </Flex>
                          <TextInput
                            ff={"Inter"}
                            fw={400}
                            w={"100%"}
                            radius="md"
                            value={entry.text}
                            placeholder="Add text"
                            onChange={(e) => {
                              const value = e.target.value;
                              setChecks((prev) =>
                                prev.map((item) =>
                                  item.field === data?._id
                                    ? {
                                        ...item,
                                        textEntries: item.textEntries?.map(
                                          (t, i) =>
                                            i === idx
                                              ? { ...t, text: value }
                                              : t,
                                        ),
                                      }
                                    : item,
                                ),
                              );
                            }}
                          />
                        </Flex>
                      ))}
                    </Box>

                    {/* ➕ Add New Entry Button */}
                    {!isFromServicePlan && type === "edit" && (
                      <Button
                        size="xs"
                        variant="light"
                        onClick={() => {
                          const newEntry = {
                            text: "",
                            staff: selectedStaffData?.id,
                            staffName: selectedStaffData?.name,
                            field: data?._id,
                            checkedAt: new Date().toISOString(),
                          };

                          setChecks((prev) =>
                            prev.map((item) =>
                              item.field === data?._id
                                ? {
                                    ...item,
                                    textEntries: [
                                      ...(item.textEntries || []),
                                      newEntry,
                                    ],
                                  }
                                : item,
                            ),
                          );
                        }}
                      >
                        + Add Text
                      </Button>
                    )}
                  </Flex>
                </HoverCard.Dropdown>
              </HoverCard>
            );
          })}
        </div>
      ),
    },
  ];

  const items = charactersList?.map((item) => (
    <Accordion.Item value={item.id} key={item.label}>
      <Accordion.Control>
        <AccordionLabel {...item} />
      </Accordion.Control>
      <Accordion.Panel>
        <Text size="sm">{item.content}</Text>
      </Accordion.Panel>
    </Accordion.Item>
  ));
  return (
    <Accordion
      multiple
      radius="0px"
      variant="contained"
      chevronPosition="right"
      defaultValue={["bender"]}
      className={classes.accordion}
    >
      {items}
    </Accordion>
  );
}

export default AccordionCheck;
